import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
    const platformId = inject(PLATFORM_ID);
    const router = inject(Router);
    const authService = inject(AuthService);

    if (isPlatformBrowser(platformId)) {
        if (authService.isLoggedIn()) {
            return true;
        }

        // If not logged in, trigger login modal and redirect to home
        authService.openLoginModal();
        return router.parseUrl('/');
    }

    // Allow SSR to pass so the client-side browser can verify the token
    return true;
};
